export const NB_SECOND_SHOW_LEVEL = 0.3;
export const NB_SECOND_RUN_CONFETTI = 1;
export const NB_SECOND_SHOW_NEXT_LEVEL = 0.5;
export const TIME_NORMAL_DAY_ANIMATION = 2.9;
export const TIME_FINAL_DAY_ANIMATION = 4.2;
export const NB_COIN = 10;
export const DURATION_COIN_ANIMATION = 1000;
export const KEYFRAMES_COIN = [
  { offset: 0, opacity: 1, hasRandom: false },
  { offset: 0.2, opacity: 1, hasRandom: false },
  { offset: 0.4, opacity: 1, hasRandom: true },
  { offset: 0.6, opacity: 1, hasRandom: true },
  { offset: 0.8, opacity: 1, hasRandom: true },
  { offset: 0.95, opacity: 0.2, hasRandom: false },
];
